import React, { useState } from "react";
import styled from "styled-components";
import { Button, Dropdown, Menu, Space } from "antd";
import { DownOutlined } from "@ant-design/icons";
import Icon from "@ant-design/icons";
import { ReactComponent as reset } from "images/filter/reset.svg";
import SearchBar from "ui/components/Dashboard/Filter/Searchbar";
import { ReactComponent as Reset } from "images/filter/reset.svg";

const Container = styled.div``;

const Topdiv = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin-bottom: 1rem;
  @media (max-width: 768px) {
    flex-direction: column;
    gap: 1rem;
  }
`;

const Left = styled.div`
  width: 60%;
  @media (max-width: 768px) {
    width: 100%;
  }
`;

const Right = styled.div`
  display: flex;
  flex-direction: row;
  gap: 0.5rem;
  @media (max-width: 768px) {
    width: 100%;
    justify-content: space-between;
  }
`;

const ResetText = styled.span`
  @media (max-width: 768px) {
    display: none;
  }
`;

const VendorRequests: React.FC = () => {
  // State for filters
  const [paymentStatusFilter, setPaymentStatusFilter] = useState<string | null>(null);
  const [selectedPaymentStatusLabel, setSelectedPaymentStatusLabel] = useState<string>("Payment status");
  const [searchQuery, setSearchQuery] = useState("");

  const handleSearch = (query: string) => {
    setSearchQuery(query);
    // Add your search logic here
  };

  // Payment status filter menu
  const paymentStatusMenu = (
    <Menu
      onClick={e => {
        setPaymentStatusFilter(e.key === "all" ? null : e.key);
        setSelectedPaymentStatusLabel(
          e.key === "all"
            ? "Payment status"
            : e.key === "ongoing"
              ? "Ongoing"
              : e.key === "complete"
                ? "Complete"
                : "Approved",
        );
        // Add your filter logic here
      }}
    >
      <Menu.Item key="all">All statuses</Menu.Item>
      <Menu.Item key="ongoing">Ongoing</Menu.Item>
      <Menu.Item key="complete">Complete</Menu.Item>
      <Menu.Item key="approved">Approved</Menu.Item>
    </Menu>
  );

  // Reset all filters
  const handleResetFilters = () => {
    setPaymentStatusFilter(null);
    setSelectedPaymentStatusLabel("Payment status");
    setSearchQuery("");
    // Add any additional reset logic here
  };

  return (
    <Container>
      <Topdiv>
        <Left>
          <SearchBar onSearch={handleSearch} />
        </Left>
        <Right>
          <Dropdown overlay={paymentStatusMenu} trigger={["click"]}>
            <Button style={{ fontSize: "13px" }}>
              <Space>
                {selectedPaymentStatusLabel}
                <DownOutlined />
              </Space>
            </Button>
          </Dropdown>

          <Button type="default" onClick={handleResetFilters} style={{ fontSize: "13px" }}>
            <Space>
              <Reset />
              <ResetText>Reset filters</ResetText>
            </Space>
          </Button>
        </Right>
      </Topdiv>
    </Container>
  );
};

export default VendorRequests;
